import React from 'react'
import { useLocation } from 'react-router'
import { Navigate, useParams } from 'react-router'
import { DetailParamType, MixImageProjectParamType, ProjectResultParamType, route } from 'routes'

export type ProjectType = 'train' | 'mix' | 'pro-filter' | 'sketch'

type LegacyProjectPageProps = {
  projectType: ProjectType
}

const LegacyProjectPage: React.FC<LegacyProjectPageProps> = props => {
  const projectType = props.projectType

  const paramTrain = useParams<keyof ProjectResultParamType>()
  const paramProFilterSketch = useParams<keyof DetailParamType>()
  const paramMix = useParams<keyof MixImageProjectParamType>()

  const location = useLocation()
  const search = location.search

  const navigateTo =
    projectType === 'train'
      ? route.TRAIN_PROJECTS.getUrl({
          id: paramTrain.id,
          subRoute: paramTrain.subRoute,
          batch: paramTrain.batch,
          order: paramTrain.order
        })
      : projectType === 'mix'
        ? route.MIX_PROJECTS.getUrl({ mixImageProjectId: paramMix.id, subRoute: paramMix.subRoute })
        : projectType === 'sketch'
          ? route.SKETCH_PROJECTS.getUrl({ id: paramProFilterSketch.id })
          : route.PRO_FILTER_PROJECTS.getUrl({ id: paramProFilterSketch.id })

  return <Navigate to={`${navigateTo}${search}`} />
}

export default LegacyProjectPage
